import styled, { css } from "styled-components";
import { motion } from "motion/react";
import NextLazyImage from "@/components/Core/NextLazyImage";
import mq from "@/utils/mq";

const InactivePreviewContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 4px;
  background: transparent;
  z-index: 150;
  position: absolute;
  pointer-events: none;
  ${mq.mobile(css`
    display: none;
  `)};
`;

const AvatarContainer = styled(motion.div)`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
`;

const Title = styled(motion.div)<{ $overFour: boolean }>`
  font-weight: 600;
  color: #fff;
  text-align: center;
  font-size: 11px;
  line-height: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  line-clamp: 1;
  padding: 0 2px;
  ${({ $overFour }) =>
    $overFour &&
    css`
      display: none;
    `};
`;

export default function StoryItemInactivePreview({ active, brandName, brandImage, overFour }) {
  const avatarAnim = {
    hidden: {
      opacity: 0,
      y: 10,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        delay: 0.22,
      },
    },
  };

  const titleAnim = {
    hidden: {
      opacity: 0,
      y: 10,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        delay: 0.25,
      },
    },
  };

  return (
    <InactivePreviewContainer>
      <AvatarContainer
        animate={!active ? "visible" : "hidden"}
        initial={!active ? "visible" : "hidden"}
        variants={avatarAnim}>
        <NextLazyImage src={brandImage.filename} alt={brandImage.alt} width={46} height={46} />
      </AvatarContainer>
      <Title
        animate={!active ? "visible" : "hidden"}
        initial={!active ? "visible" : "hidden"}
        variants={titleAnim}
        $overFour={overFour}>
        {brandName}
      </Title>
    </InactivePreviewContainer>
  );
}
